import { useEffect, useState } from 'react';
import { supabase } from '../supabase';

export default function useNotifications(userId) {
  const [notifications, setNotifications] = useState([]);

  useEffect(() => {
    if (!userId) return;
    // Subscribe to rewrites table for new rewrites of user's reminders
    const rewriteSub = supabase
      .channel('rewrites-notify')
      .on('postgres_changes', { event: 'INSERT', schema: 'public', table: 'rewrites' }, payload => {
        if (payload.new.reminder_owner_id === userId) {
          setNotifications(n => [
            { message: 'Someone rewrote your reminder!', time: new Date().toLocaleTimeString(), read: false },
            ...n
          ]);
        }
      })
      .subscribe();
    // Subscribe to votes table for new votes on user's rewrites
    const voteSub = supabase
      .channel('votes-notify')
      .on('postgres_changes', { event: 'INSERT', schema: 'public', table: 'votes' }, payload => {
        if (payload.new.rewrite_owner_id === userId) {
          setNotifications(n => [
            { message: 'Your rewrite received a new vote!', time: new Date().toLocaleTimeString(), read: false },
            ...n
          ]);
        }
      })
      .subscribe();
    // Subscribe to achievements table for new achievements for the user
    const achievementSub = supabase
      .channel('achievements-notify')
      .on('postgres_changes', { event: 'INSERT', schema: 'public', table: 'achievements' }, payload => {
        if (payload.new.user_id === userId) {
          setNotifications(n => [
            { message: `Achievement unlocked: ${payload.new.title} ${payload.new.emoji || ''}`, time: new Date().toLocaleTimeString(), read: false },
            ...n
          ]);
        }
      })
      .subscribe();
    return () => {
      supabase.removeChannel(rewriteSub);
      supabase.removeChannel(voteSub);
      supabase.removeChannel(achievementSub);
    };
  }, [userId]);

  const markAllRead = () => {
    setNotifications(n => n.map(notif => ({ ...notif, read: true })));
  };

  return { notifications, markAllRead };
} 